import { basicValidation } from "../basicValidation";
import { articleChangeImportanceValues, articleEmailTags, releaseRecordStates } from "../../../DTOs";

export const articleValidation = {
    articleList: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        name: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
    },

    articleTopic: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        listId: (value: string) => basicValidation.resourceId.isValid(value),
        name: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
    },

    articleType: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        name: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
    },

    article: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        articleVersionId: (value: string) => basicValidation.resourceId.isValid(value),
        version: (value: number) => basicValidation.validateInteger(value, 1, 1000),
        title: (value: string) => basicValidation.resourceText.isValid(value, false, 400),
        description: (value: string) => basicValidation.resourceText.isValid(value, true, 20000),
        reference: (value: string) => basicValidation.resourceText.isValid(value, true, 100),
        date: (value: Date | null) => basicValidation.dateOrNull(value),
        url: (value: string) => basicValidation.resourceText.isValid(value, true, 500),
        changeDescription: (value: string) => basicValidation.resourceText.isValid(value, true, 20000),
        assessment: (value: string) => basicValidation.resourceText.isValid(value, true, 20000),
        importance: (value: string) => articleChangeImportanceValues.some(v => v === value),
        requirements: (value: string) => basicValidation.resourceText.isValid(value, true, 20000),
        categoryTag: (value: string) => basicValidation.resourceText.isValid(value, true, 50),
    },
    articleSubscriber: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
    },
    articleNote: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        note: (value: string) => basicValidation.resourceText.isValid(value, false, 5000),
    },

    articleAppendixVersion: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        appendixId: (value: string) => basicValidation.resourceId.isValid(value),
        title: (value: string) => basicValidation.resourceText.isValid(value, false, 400),
        description: (value: string) => basicValidation.resourceText.isValid(value, true, 5000),
        reference: (value: string) => basicValidation.resourceText.isValid(value, true, 100),
        date: (value: Date | null) => basicValidation.dateOrNull(value),
        url: (value: string) => basicValidation.resourceText.isValid(value, true, 500)
    },
    articleReleaseRecord: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        customChangeDescription: (value: string) => basicValidation.resourceText.isValid(value, true, 5000),
        customAssessment: (value: string) => basicValidation.resourceText.isValid(value, true, 5000),
        customImportance: (value: string) => articleChangeImportanceValues.some(v => v === value),
        customEmailTemplate: (value: string) =>
        {
            if (!basicValidation.resourceText.isValid(value, true, 5000))
                return false;

            const tagMatches = value.match(/{(.*?)}/g); // Find all matches of the form {someText}
            //console.log('customEmailTemplate tagMatches:', tagMatches);
            if (!tagMatches){
                return true; // No tags found, valid template
            }

            if (tagMatches.some(t => articleEmailTags.every(et => et !== t)))
            {
                //console.log('customEmailTemplate invalid tags:', tagMatches.filter(t => articleEmailTags.every(et => et !== t)));
                return false;
            }

            return true;
        },
        status: (value: string) => releaseRecordStates.some(v => v === value),
    },

    siteArticleEvaluation: {
        articleVersionId: (value: string) => basicValidation.resourceId.isValid(value),
        evaluationText: (value: string) => basicValidation.resourceText.isValid(value, false, 5000),
        evaluationImportance: (value: string | null) => value === null || articleChangeImportanceValues.some(v => v === value),
    },
    siteArticleRequirements: {
        articleId: (value: string) => basicValidation.resourceId.isValid(value),
        requirementsText: (value: string) => basicValidation.resourceText.isValid(value, true, 5000),
    },
    siteArticleOwner: {
        ownerUserId: (value: string | null) => value === null || basicValidation.resourceId.isValid(value),
    },
    internalArticle:{
        id: (value: string) => basicValidation.resourceId.isValid(value),
        title: (value: string) => basicValidation.resourceText.isValid(value, false, 400),
        description: (value: string) => basicValidation.resourceText.isValid(value, false, 5000),
        ownerUserId: (value: string | null) => value === null || value === '' || basicValidation.resourceId.isValid(value),
    },
    internalArticleChange:{
        id: (value: string) => basicValidation.resourceId.isValid(value),
        active: (value: boolean) => typeof value === 'boolean',
        changeDescription: (value: string) => basicValidation.resourceText.isValid(value, true, 5000),
        date: (value: Date | null) => basicValidation.dateOrNull(value),
        evaluationImportance: (value: string | null) => value === null || articleChangeImportanceValues.some(v => v === value),
        evaluationText: (value: string) => basicValidation.resourceText.isValid(value, true, 5000)
    }
};